goog.provide('el8.ext.onboarding.dataAuthForm');

goog.require('el8.ext.Form');
goog.require('el8.template.ext.onboarding.dataAuthForm');
goog.require('el8.uiwidget.confirm');
goog.require('el8.ext.onboarding.ButtonSet');
goog.require('el8.util.consts');
goog.require('el8.ext.onboarding.baDetailsDialog');
goog.require('el8.ext.onboarding.addlLabsDialog');


el8.ext.onboarding.dataAuthForm.init = function(spec) {

    var formGuide = spec.formGuide;
    var formName = spec.name;

    var existingLabs = [
        {name: 'quest', displayName: 'Quest', imageUrl: '/static/images/partners/quest_139x60.png'},
        {name: 'muir', displayName: 'Muir Lab', imageUrl: '/static/images/partners/muirlab_125x60.png'},
        {name: 'labcorp', displayName: 'LabCorp', imageUrl: '/static/images/partners/labcorp_117x60.png'}
    ];

    var $container = spec.container.find('.form-guide-container');

    $container.html(el8.template.ext.onboarding.dataAuthForm.content({
        labsList: existingLabs
    }));

    var $form = $('form', $container);
    var $sigBox = $('.signature-box', $container);

    var fields = [];
    existingLabs.map(function(l) {
        fields.push({
            name: l.name,
            selector: ':input[name="'+l.name+'"]'
        });
    });
    fields.push({
        name: 'authorize',
        selector: ':input[name="authorize"]',
        validate: {
            required: true
        },
        validateMsgs: {
            required: 'Required Field: please check the box to authorize ElationEMR to act on your behalf'
        }
    });
    fields.push({
        name: 'signature',
        infoText: 'Type your name here...',
        size: 'large',
        selector: ':input[name="signature"]',
        validate: {
            required: true
        },
        validateMsgs: {
            required: 'Required Field'
        }
    });

    var validationOpts = el8.ext.util.validationOpts();
    validationOpts['errorPlacement'] = function(error, element) {
        var name = $(element).attr('name');
        if (name === 'authorize') {
            var $existing = $('.error-msg[data-name="'+name+'"]', $container);
            $existing.text($(error).text());

        // as normal
        } else {
            $(error).attr('data-name', name);
            var $existing = $(element).prev('.error-msg');
            if ($existing.length) {
                $existing.replaceWith($(error));
            } else {
                $(error).insertBefore($(element));
            }
        }
    };
    validationOpts['unhighlight'] = function(element, errorClass) {

        el8.ext.util.unhighlightError($(element));

        var name = $(element).attr('name');
        if (name === 'authorize') {
            $('.error-msg[data-name="'+name+'"]', $container).empty();
        // as normal
        } else {
            $(element).prevAll('.error-msg').empty();
        }
    };

    var that = new el8.ext.Form({
        container: $form,
        name: formName,
        buttonSetConstructor: el8.ext.onboarding.ButtonSet,
        buttonElt: spec.container.find('.form-guide-buttons'),
        fields: fields,
        validationOpts: validationOpts
    });
    that.addButton('next', 'Continue to Step 3 of 3', function(_form, $btn) {
        if (that.isValid()) {
            var selectedLabs = that._getAllLabs();
            if (!selectedLabs.length) {
                el8.uiwidget.confirm(
                    'You have not selected a lab vendor. Would you like to skip this option and retrieve your patients\' historical lab results at a later time?',
                    function() { that._goToNextForm(selectedLabs, $btn); }
                );
            } else {
                that._goToNextForm(selectedLabs, $btn);
            }
        }
    }, true);
    that.addButton('back', 'Back', function(_form) {
        formGuide.prev(formName);
    }, false);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    var super_render = that.render;
    that.render = function() {
        super_render.call(that);
        $('.signature-name', $container).text(el8.ext.onboarding.signupData.getFormalName());
        that.populate({
            authorize: el8.ext.onboarding.signupData.isAuthorized(),
            signature: el8.ext.onboarding.signupData.getSignature()
        });
        var selectedLabs = el8.ext.onboarding.signupData.getSelectedLabs();
        if (selectedLabs) {
            that.populate({
                muir: selectedLabs.has('muir'),
                labcorp: selectedLabs.has('labcorp'),
                quest: selectedLabs.has('quest')
            });
        }
        _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/show/']);
    };

    var super_isValid = that.isValid;
    that.isValid = function() {
        return super_isValid.call(that) && that.getVal('authorize');
    };

    that._goToNextForm = function(selectedLabs, $btn) {
        if (!that.isValid()) { return; }
        $btn.prop('disabled', true);

        el8.ext.onboarding.signupData.populate({
            selectedLabs: selectedLabs,
            signature: that.getVal('signature'),
            isAuthorized: true
        });

        var mapped = {
            labs: selectedLabs,
            complete: false
        };
        mapped['user_signature'] = that.getVal('signature');
        mapped['user_agrees_to_ba'] = true;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('signup', [el8.ext.onboarding.signupData.getId()]),
            data: {data: JSON.stringify(mapped)},
            success: function() {
                formGuide.next(formName);
                $btn.prop('disabled', false);
            },
            error: function() {
                formGuide.showErrorPage();
            }
        });
    };

    that._bindTriggers = function() {
        $container.on('click', ':input[name="authorize"]',  function(e) {
            var isChecked = $(this).is(':checked');
            if (isChecked) {
                $sigBox.show();
                that.focusField('signature');
                _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/check-off-ba/']);
            } else {
                $sigBox.hide();
                that.setVal('signature', '');
            }
        }).on('click', '.lab-image',  function(e) {
            var name = $(this).attr('data-name');
            var $cb = $(':input[name="'+name+'"]', $container);
            $cb.prop("checked", !$cb.is(':checked'));
        }).on('click', '.addl-labs-trigger',  function(e) {
            el8.ext.onboarding.addlLabsDialog.show({
                saveCb: function(text) {
                    if (text) {
                        $('.addl-labs-trigger').text("We will look into adding these lab vendors for you: "+text);
                    } else {
                        $('.addl-labs-trigger').text("Don't see your lab vendors?");
                    }
                }
            });

        }).on('click', '.details-trigger',  function(e) {
            if ($(this).attr('data-name') === 'ba') {
                el8.ext.onboarding.baDetailsDialog.show();
                _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/read-ba/']);
            }
        });
    };

    /******************
     * Validation methods
     *****************/
    that._validateAuthorize = function() {
        if (!that.getVal('authorize')) {
            return false;
        } else {
            return true;
        }
    };
    that._validateSignature = function() {
    };


    /******************
     * Helper methods
     *****************/
    that._getAllLabs = function() {
        var results = [];
        $('input:checkbox:checked[data-type="lab"]', $container).each(function(index, elt) {
            results.push($(elt).val());
        });
        if (el8.ext.onboarding.signupData.getAddlLabs()) {
            results.push(el8.ext.onboarding.signupData.getAddlLabs());
        }
        return results;
    };

    return that;

};
